<script>
/**
 * @file       Comment intersection observer component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import { commentsMixin } from "@/modules/comments/mixins.js";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "intersectionObserver",
  mixins: [commentsMixin],
  abstract: true,
  props: {
    threshold: {
      type: Array
    }
  },

  render() {
    try {
      return this.$slots.default[0];
    } catch (e) {
      throw new Error(
        "IntersectionObserver.vue can only render one, and exactly one child component."
      );
    }
  },

  mounted() {
    this.observer = new IntersectionObserver(
      entries => {
        this.$emit(
          entries[0].isIntersecting ? "intersect-enter" : "intersect-leave",
          [entries[0]]
        );
      },
      {
        threshold: this.threshold || 0
      }
    );
    this.$nextTick(() => {
      this.observer.observe(this.$slots.default[0].elm);
    });
  },

  destroyed() {
    this.observer.disconnect();
  }
};
</script>
